import { render, staticRenderFns } from "./admin-icon.vue?vue&type=template&id=88c3fd7c"
import script from "./admin-icon.vue?vue&type=script&lang=js"
export * from "./admin-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88c3fd7c')) {
      api.createRecord('88c3fd7c', component.options)
    } else {
      api.reload('88c3fd7c', component.options)
    }
    module.hot.accept("./admin-icon.vue?vue&type=template&id=88c3fd7c", function () {
      api.rerender('88c3fd7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin-icon.vue"
export default component.exports